import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";

import SectionCarousel from "./Sections/SectionCarousel";

import DashboardLoggedIn from "components/ManualOrder/DashboardLogged/DashboardLoggedIn";

const useStyles = makeStyles(sectionsPageStyle);

export default function SectionsPage() {
	const classes = useStyles();

	return (
		<div>
			<Header
				// color="info"
				color="transparent"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<div className={`${classes.main} `}>
				<div className="pt-10">
					<SectionCarousel />
				</div>
				<DashboardLoggedIn />
			</div>
		</div>
	);
}
